import { apiSuccessHandler, apiErrorHandler } from "./apiHandler";
import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { message } from "antd";

import { store } from "store";
import qs from "qs";

const baseurl = `${process.env.REACT_APP_API_URL}`;
let isLogOut = false;
// ========================== base setting ============================
const createAxios = (baseURL) => {
  const newInstance = axios.create({ baseURL, withCredentials: true });

  newInstance.interceptors.response.use(
    (config) => {
      // # put, post, delete 時，呼叫
      // if (config.config.method !== "get") apiSuccessHandler(config.data);
      isLogOut = false;
      return config;
    },
    (error) => {
      if (error.response && !isLogOut) {
        if (error.response.status == 401) {
          message.error("憑證過期，畫面將轉至登入頁面", [4000]);
          setTimeout(() => window.location.assign(`/login`), 2000);
          isLogOut = true;
        }
        if (
          error.response.data.code == 130002 &&
          error.response.status == 403 &&
          error.response.config.method !== "get"
        )
          apiErrorHandler(error.response, "帳號權限不足");
        // if (!localStorage.getItem("persist:root")) {
        //   apiErrorHandler(error.response, "憑證過期，請重新登入");
        //   setTimeout(() => window.location.assign(`/login`), 2200);
        // }
      }

      return Promise.reject(error);
    },
  );
  newInstance.interceptors.request.use(
    function (config) {
      // 從 localStorage 將 token 取出
      // const token = store.getState().tokenStore.token;
      const token = sessionStorage.t;
      // 如果 token 存在的話，則帶入到 headers 當中
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    },
  );

  return newInstance;
};

// 登入
const authRequest = createAxios(`${baseurl}/Authentication`);
// 活動
const activityRequest = createAxios(`${baseurl}/Activity`);
// 訂單
const orderRequest = createAxios(`${baseurl}/Order`);
// 管理員
const adminRequest = createAxios(`${baseurl}/Admin`);
// 使用者
const meRequest = createAxios(`${baseurl}/me`);
// 稅務
const taxRequest = createAxios(`${baseurl}/tax`);
// 匯出
const exportRequest = createAxios(`${baseurl}/export`);
// 會員
const memberRequest = createAxios(`${baseurl}/member`);

// POST 登入
export const apiLogIn = (data) => authRequest.post(`Verification`, data);
// POST 登出
export const apiLogOut = (data) => authRequest.post(`logout`, data);

// GET 取得管理員列表
export const apiGetAdmin = ({ account, name, phone, email, role }) =>
  adminRequest.get(``, { params: { account, name, phone, email, role } });

// GET 取得當前使用者
export const apiGetMe = () => meRequest.get(``);

// GET 取得活動列表
export const apiGetEventList = ({
  title,
  status,
  offset,
  limit,
  sortFields,
  sortDirection,
}) =>
  activityRequest.get(``, {
    params: {
      title,
      status,
      offset,
      limit,
      fields: sortFields,
      direction: sortDirection,
    },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
// POST 複製活動
export const apiCopyEvent = ({ id }) => activityRequest.post(`/copy/${id}`);
// POST 新增活動列表
export const apiPostEventList = (data) => activityRequest.post(``, data);
// GET 取得活動內容
export const apiGetEventContent = ({ id }) =>
  activityRequest.get(`/${id}`, {
    params: {},
  });
// GET 檢查客製化網址是否重複
export const apiCheckEventCode = ({ id, code }) =>
  activityRequest.get(`/${id}/Code`, {
    params: { code },
  });
// DELETE 刪除活動
export const apiDeleteEvent = ({ id }) => activityRequest.delete(`/${id}`);
// PATCH 更新活動狀態
export const apiUpdateEventStatus = ({ id, status }) =>
  activityRequest.patch(`/${id}`, { status });
// PUT 更新活動內容
export const apiPutEventContent = ({
  id,
  summary,
  introduction,
  notification,
}) =>
  activityRequest.put(`/${id}/content`, {
    summary,
    introduction,
    notification,
  });

// GET 獲取會員列表
export const apiGetMember = ({ fuzzySearch, offset, limit }) =>
  memberRequest.get(``, { params: { fuzzySearch, offset, limit } });

// GET 獲取票券列表
export const apiGetTickets = ({ id, paging, offset, limit }) =>
  activityRequest.get(`/${id}/ticket`, {
    params: {
      offset,
      limit,
    },
  });

// GET 取得票券詳情
export const apiGetTicketDetail = ({ id, ticketId }) =>
  activityRequest.get(`/${id}/ticket/${ticketId}`);

// POST 複製票券
export const apiCopyTicket = ({ id, ticketId }) =>
  activityRequest.post(`/Ticket/Copy/${ticketId}`);

// DELETE 刪除票券列表
export const apiDeleteTickets = ({ id, ticketId }) =>
  activityRequest.delete(`/${id}/ticket/${ticketId}`);

// GET 取得票券統計
export const apiGetTicketStatistic = ({ id, offset, limit }) =>
  activityRequest.get(`/${id}/ticket/statistic`, {
    params: {
      offset,
      limit,
    },
  });

// GET 取得活動統計
export const apiGetStatistic = ({ id }) =>
  activityRequest.get(`/${id}/statistic`);

// GET 獲取票券政策
export const apiGetTicketPolicy = ({ id }) =>
  activityRequest.get(`/ticket/policy/${id}`);

// POST 更新票券政策
export const apiCreateTicketPolicy = ({ data }) =>
  activityRequest.post(`/ticket/policy`, data);

// PUT 更新票券政策
export const apiUpdateTicketPolicy = ({ id, data }) =>
  activityRequest.put(`/ticket/policy/${id}`, data);

// DELETE 刪除票券政策
export const apiDeleteTicketPolicy = ({ id }) =>
  activityRequest.delete(`/ticket/policy/${id}`);

// GET 獲取參加名單列表
export const apiGetOrder = ({
  sourceId,
  orderId,
  name,
  fuzzySearch,
  email,
  phone,
  status,
  shipStatus,
  offset,
  limit,
  specificSourceId,
}) =>
  orderRequest.get(`/detail`, {
    params: {
      sourceId,
      orderId,
      name,
      fuzzySearch,
      email,
      phone,
      status,
      shipStatus,
      offset,
      limit,
      specificSourceId,
    },
  });

// GET 製作參加名單檔案
export const apiGetCreateOrderFiles = ({
  sourceId,
  fuzzySearch,
  status,
  shipStatus,
  offset,
  limit,
  specificSourceId,
}) =>
  orderRequest.get(`/detail/export`, {
    params: {
      sourceId,
      fuzzySearch,
      status,
      shipStatus,
      offset,
      limit,
      specificSourceId,
    },
  });
// GET 匯出參加名單檔案
export const apiGetExportFiles = ({ id }) => exportRequest.get(`${id}`);

// PUT 更新參加名單
export const apiPutOrder = ({
  detailId,
  name,
  phone,
  email,
  status,
  shipStatus,
  remark,
}) =>
  orderRequest.put(`/detail/${detailId}`, {
    name,
    email,
    phone,
    status,
    shipStatus,
    remark,
  });

// PUT 補發票券
export const apiPutResend = ({ detailId }) =>
  orderRequest.put(`/detail/${detailId}/send`, {});

// PUT 驗票
export const apiCheckIn = ({ secretKey }) =>
  orderRequest.put(`detail/verification`, { secretKey });

// POST 發送公關票
export const apiSendPr = (data) => orderRequest.post(`pr`, data);

// POST 退票
export const apiRefund = (data, reason) =>
  orderRequest.post(``, { reason, detailIds: data });

// PUT 換票
export const apiSwitchTicket = ({ id, sourceId }) =>
  orderRequest.put(`detail/${id}/reassign`, { sourceId });

// GET 取得稅務
export const apiGetTax = (fuzzySearch, paging) =>
  taxRequest.get(``, { fuzzySearch, paging });

// POST 驗票
export const apiPostTax = ({
  name,
  issuer,
  prefix,
  format,
  amount,
  originalSerialNumber,
}) =>
  taxRequest.post(``, {
    name,
    issuer,
    prefix,
    format,
    amount,
    originalSerialNumber,
  });

// DELETE 發送公關票
export const apiDeleteTax = ({ id }) => taxRequest.delete(`/${id}`);
